// React Basic and Bootstrap
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Container, Media } from "reactstrap";

//Import Icons
import FeatherIcon from "feather-icons-react";

// import images
import contactDetail from "../../../assets/images/water-glass.jpg";
import Topbar from "../../../components/Layout/Topbar";

class PageContactDetail extends Component {
  constructor(props) {
    super(props);
    this.sendMail.bind(this);
    this.callNumber.bind(this);
  }

  sendMail() {
    window.location.href = "mailto:CCOSCare@WaterCCOS.com";
  }

  callNumber() {
    window.location.href = "tel:6145402408";
  }

  callNumberAfterHours() {
    window.location.href = "tel:8773495441";
  }

  render() {
    return (
      <React.Fragment>
        <Topbar />

        <section
          className="vh-100 d-flex align-items-center"
          style={{ background: `url(${contactDetail}) center center` }}
        >
          <div className="bg-overlay bg-overlay-white"></div>
          <Container>
            <Row className="align-items-center">
              <Col lg={{ size: 6, offset: 6 }} md={{ size: 7, offset: 5 }}>
                <div className="title-heading mt-5 pt-4">
                  <h1 className="heading">Get In Contact with Us</h1>
                  {/* <p className="text-dark">
                    <span className="text-primary font-weight-bold">CCOS</span>{" "}
                    offers business hour phone support, email support and after
                    hour repair numbers.
                  </p> */}

                  <Media className="contact-detail align-items-center mt-3">
                    <div className="icon">
                      <i>
                        <FeatherIcon
                          icon="mail"
                          className="fea icon-m-md text-dark mr-3"
                        />
                      </i>
                    </div>
                    <Media body className="content">
                      <h4 className="title font-weight-bold mb-0">Email</h4>
                      <Link
                        to="#"
                        onClick={this.sendMail}
                        className="text-primary"
                      >
                        CCOSCare@WaterCCOS.com
                      </Link>
                    </Media>
                  </Media>

                  <Media className="contact-detail align-items-center mt-3">
                    <div className="icon">
                      <i>
                        <FeatherIcon
                          icon="phone"
                          className="fea icon-m-md text-dark mr-3"
                        />
                      </i>
                    </div>
                    <Media body className="content">
                      <h4 className="title font-weight-bold mb-0">Phone</h4>
                      <p>Monday - Friday, 8:30am to 4:30pm</p>
                      <Link
                        to="#"
                        onClick={this.callNumber}
                        className="text-primary"
                      >
                        614.540.2408
                      </Link>
                    </Media>
                  </Media>
                  {/* 
                  <Media className="contact-detail align-items-center mt-3">
                    <div className="icon">
                      <i>
                        <FeatherIcon
                          icon="phone"
                          className="fea icon-m-md text-dark mr-3"
                        />
                      </i>
                    </div> */}
                  {/* <Media body className="content">
                      <h4 className="title font-weight-bold mb-0">Phone</h4>
                      <p>After Hours- Outage Notification Line</p>
                      <Link
                        to="#"
                        onClick={this.callNumberAfterHours}
                        className="text-primary"
                      >
                        877.349.5441
                      </Link>
                    </Media>
                  </Media> */}

                  <Media className="contact-detail align-items-center mt-3">
                    <div className="icon">
                      <i>
                        <FeatherIcon
                          icon="map-pin"
                          className="fea icon-m-md text-dark mr-3"
                        />
                      </i>
                    </div>
                    <Media body className="content">
                      <h4 className="title font-weight-bold mb-0">
                        Mail Payments
                      </h4>
                      <Link to="#" className="video-play-icon text-primary">
                        Columbus Central Ohio Systems <br></br>
                        PO Box 645860 <br></br>
                        Pittsburgh, PA 15264
                      </Link>
                    </Media>
                  </Media>

                  <ul className="list-unstyled social-icon mb-0 mt-4">
                    {/* <li className="list-inline-item"><Link to="#" className="rounded mr-1"><i><FeatherIcon icon="facebook" className="fea icon-sm fea-social" /></i></Link></li>
                                                <li className="list-inline-item"><Link to="#" className="rounded mr-1"><i><FeatherIcon icon="instagram" className="fea icon-sm fea-social" /></i></Link></li>
                                                <li className="list-inline-item"><Link to="#" className="rounded mr-1"><i><FeatherIcon icon="twitter" className="fea icon-sm fea-social" /></i></Link></li>
                                                <li className="list-inline-item"><Link to="#" className="rounded mr-1"><i><FeatherIcon icon="linkedin" className="fea icon-sm fea-social" /></i></Link></li> */}
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
export default PageContactDetail;
